import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';
import { TransitionStatus } from 'react-transition-group';
import { ENTERED, ENTERING } from 'react-transition-group/Transition';

import { transitionDuration } from '@/components/layouts/Modal/Base/style';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(
  (props: { transitionStatus: TransitionStatus; baseZIndex: number }) =>
    mq({
      position: 'fixed',
      right: [ENTERING, ENTERED].includes(props.transitionStatus)
        ? '0'
        : ['0', '0', '-75%', '-840px'],
      bottom: [ENTERING, ENTERED].includes(props.transitionStatus)
        ? ['0', '0', isMobile ? '72px' : defaultTheme.spacing.l]
        : ['-100vh', '-100vh', isMobile ? '72px' : defaultTheme.spacing.l],
      width: ['100%', '100%', '75%', '840px'],
      minWidth: ['320px', '320px', '730px', '840px'],
      height: [
        'auto',
        'auto',
        isMobile ? `calc(100vh - 88px)` : `calc(100vh - 32px)`,
      ],
      maxHeight: [
        `calc(var(--vh) - ${defaultTheme.spacing.l})`,
        `calc(var(--vh) - ${defaultTheme.spacing.l})`,
        isMobile ? `calc(100vh - 88px)` : `calc(100vh - 32px)`,
      ],
      borderRadius: [
        `${defaultTheme.border.radius.l} ${defaultTheme.border.radius.l} 0 0`,
        `${defaultTheme.border.radius.l} ${defaultTheme.border.radius.l} 0 0`,
        `${defaultTheme.border.radius.l} 0 0 ${defaultTheme.border.radius.l}`,
      ],
      backgroundColor: defaultTheme.background.lightGray,
      padding: [
        `${defaultTheme.spacing.l} 0 160px 0`,
        `${defaultTheme.spacing.l} 0 160px 0`,
        defaultTheme.spacing.xxl,
      ],
      zIndex: props.baseZIndex + 1,
      overflowY: 'auto',
      transition: `all ${transitionDuration}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
    }),
);

export const Header = styled.div(() =>
  mq({
    position: 'relative',
    textAlign: ['center', 'center', 'left', 'left'],
    marginBottom: defaultTheme.spacing.xxl,
    p: {
      fontWeight: 'bold',
    },
  }),
);

export const Title = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
  }),
);

export const LeftWrapper = styled.div(() =>
  mq({
    width: ['100%', '100%', `calc(100% / 2 - ${defaultTheme.spacing.m})`],
    maxHeight: [
      'auto',
      'auto',
      isMobile ? 'calc(100vh - 192px)' : 'calc(100vh - 132px)',
    ],
    overflowY: ['hidden', 'hidden', 'auto'],
  }),
);

export const RightWrapper = styled.div(() =>
  mq({
    position: ['block', 'block', 'sticky'],
    top: 0,
    width: [
      '100%',
      '100%',
      `calc(100% / 2 - ${defaultTheme.spacing.m})`,
      `calc(100% / 2 - ${defaultTheme.spacing.m})`,
    ],
    maxHeight: [
      'auto',
      'auto',
      isMobile ? 'calc(100vh - 212px)' : 'calc(100vh - 132px)',
    ],
    overflowY: ['hidden', 'hidden', 'auto'],
  }),
);

export const ContentWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    justifyContent: ['inherit', 'inherit', 'space-between', 'space-between'],
    alignItems: ['inherit', 'inherit', 'flex-start', 'flex-start'],
  }),
);
